module.exports = __webpack_public_path__ + "img/wechat-pay.dab5ff8f.svg";